import * as React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import { useTranslation } from 'react-i18next';

const PricesPage = () => {
  const { t } = useTranslation();
  return (
    <div className="flex-grow flex flex-col items-center justify-center">
      <Player
        autoplay
        loop
        src="https://assets8.lottiefiles.com/private_files/lf30_hdwhneal.json"
        style={{ width: '300px' }}
      ></Player>
      <div className="font-bd text-3-2 text-center mt-1-0">
        {t('farm.comming_soon')}
      </div>
      <div className="font-rg text-1-8 text-center m-1-0">
        {t('farm.description')}
      </div>
    </div>
  );
};

export default PricesPage;
